import Agent from './Agent';
import {
  type AgentSuggestions,
  type AgentParams,
  type AgentInstances,
} from './Agent';

class WhiteboardAgent extends Agent {
  static name = 'WhiteboardAgent';

  static publicName = 'Whiteboard';

  static available(
    _agentParams: AgentParams,
    agentInstances: AgentInstances
  ): boolean {
    return !!(
      window.currentAccount?.hasGeneralAiAssistant &&
      window.featureFlags.awt_390_whiteboard_ai_assistant &&
      agentInstances.assistedWhiteboard
    );
  }

  isReasoningEnabledByDefault(): boolean {
    return true;
  }

  getSuggestions(): AgentSuggestions {
    return [
      {
        title: 'Organize',
        prompt:
          'Tell me how you want the shapes organized and what themes or categories you want to group them by.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to arrange shapes on my whiteboard.\n\nLet's start...\n\nI want to organize my whiteboard by: `,
        icon: 'refine',
      },
      {
        title: 'Summarize',
        prompt: 'Tell me what aspects of the whiteboard you want summarized.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to summarize the content of my whiteboard.\n\nLet's start...\n\nPlease summarize: `,
        icon: 'summarize',
      },
      {
        title: 'Wireframe',
        prompt:
          'Tell me what type of wireframe you want to create and for what purpose.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to generate a wireframe on my whiteboard.\n\nLet's start...\n\nI want to create a wireframe for: `,
        icon: 'whiteboard',
      },
    ];
  }
}

Agent.register(WhiteboardAgent);

export default WhiteboardAgent;
